"use strict";

import '../notices';

App.Pages.Notices.Notice = class Notice extends PF.Widget
	{
	constructor(noticeData)
		{
		super();
		this.noticeData = noticeData;
		// this.noticeData.data = JSON.parse(this.noticeData.data);

		this.noticeData.notice2User = this.noticeData.notice2Users[0];
		this.read = this.noticeData.notice2User.read === 1;
		}

	onRender(event)
		{
		this.dom = Platform.processTemplate($(event.node), this.dom);
		this.bindNode('read', this.dom.card, MK.binders.className('read'));

		this.timeInViewport = 0;
		this.reedInterval = setInterval(() => {
			if (this.noticeData.notice2User.read === "1")
				{
				clearInterval(this.reedInterval);
				return;
				}

			if (this.isAnyPartOfElementInViewport() === true)
				{
				this.timeInViewport += 100;
				if (this.timeInViewport > 1000)
					{
					this.trigger('viewed', this);
					}
				}
			else
				{
				this.timeInViewport = 0;
				}
		}, 100);
		}

	isAnyPartOfElementInViewport()
		{
		const rect = this.dom.card.node.getBoundingClientRect();
		// DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
		const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
		const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

		// http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
		const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
		const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

		return (vertInView && horInView);
		}

	get body()
		{
		return '';
		}

	get f7body()
		{
		return this.body;
		}

	};